/* ARTMIE HR rewriter v1 (loop-safe) — generated 2026-05-17T09:13:39.585Z */
/*
   Translates SK→HR UI strings client-side for the Hrvatska market.
   Activates when EITHER:
     - the URL path starts with /hr-hr/ (pre-cutover staging via subfolder), OR
     - the hostname matches artmie.hr (post-DNS-cutover dedicated domain), OR
     - window.ArtmieHR === true (manual override for testing).

   Loop guard: pairs whose replacement contains the source are filtered out at runtime
   so we never recurse on a partial match.
*/
(function () {
  var __path = (window.location.pathname || '');
  var __host = (window.location.hostname || '');
  var pathMode = /^\/(hr-hr)(\/|$)/.test(__path);
  var hostMode = /(^|\.)artmie\.hr$/i.test(__host);
  if (!pathMode && !hostMode && window.ArtmieHR !== true) return;

  document.documentElement.classList.add('hr-market');
  document.documentElement.setAttribute('data-hr-market', '1');

  /* FORCE_MARKET — ensure Shopify market context = HR when on subfolder.
     Skipped when on the dedicated domain since Shopify resolves the market by host. */
  function ensureMarket() {
    if (!pathMode) return;
    try {
      if (sessionStorage.getItem('artmie_hr_market_set') === '1') return;
      var formData = new FormData();
      formData.append('form_type', 'localization');
      formData.append('_method', 'PUT');
      formData.append('country_code', 'HR');
      formData.append('language_code', 'hr');
      formData.append('return_to', window.location.pathname);
      fetch('/localization', { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function () { sessionStorage.setItem('artmie_hr_market_set', '1'); })
        .catch(function () {});
    } catch (e) {}
  }
  ensureMarket();

  /* CSS injection — hide app-store links sitewide (no IT app). */
  function injectCss() {
    if (document.getElementById('artmie-hr-injected-css')) return;
    var s = document.createElement('style');
    s.id = 'artmie-hr-injected-css';
    s.textContent = [
      'a[href*="apps.apple.com"]{display:none !important;}',
      'a[href*="itunes.apple.com"]{display:none !important;}',
      'a[href*="play.google.com"]{display:none !important;}',
      'a[href*="app.appsflyer.com"]{display:none !important;}',
      '.artmie-app-link-separator{display:none !important;}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);
  }
  injectCss();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectCss);

  /* DOM hider — climb from any app-store link to a row container and hide it. */
  function hideAppBlocks() {
    var appLinks = document.querySelectorAll('a[href*="apps.apple.com"],a[href*="itunes.apple.com"],a[href*="play.google.com"],a[href*="app.appsflyer.com"]');
    for (var i = 0; i < appLinks.length; i++) {
      var el = appLinks[i];
      for (var j = 0; j < 6 && el && el.parentElement; j++) {
        el = el.parentElement;
        var tag = el.tagName && el.tagName.toLowerCase();
        var cls = (el.className && el.className.baseVal !== undefined) ? el.className.baseVal : (el.className || '');
        cls = String(cls);
        if (tag === 'li' || /(\brow\b|\bitem\b|\bcard\b|\bblock\b|\bpdp\b|\binfo\b|delivery|shipping|app)/i.test(cls)) {
          el.style.display = 'none';
          break;
        }
      }
    }
    var phrases = ["Stiahni si ARTMiE appku","Stiahni si ARTMIE appku","S aplikáciou doprava zdarma"];
    for (var k = 0; k < phrases.length; k++) {
      var p = phrases[k];
      var walker = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT, null);
      var t;
      while ((t = walker.nextNode())) {
        if (t.nodeValue && t.nodeValue.indexOf(p) !== -1) {
          var node = t.parentElement;
          for (var m = 0; m < 6 && node && node.parentElement; m++) {
            var nc = node.className || '';
            nc = String(nc.baseVal !== undefined ? nc.baseVal : nc);
            var nt = node.tagName && node.tagName.toLowerCase();
            if (nt === 'li' || /(\brow\b|\bitem\b|\bcard\b|\bblock\b|\bpdp\b|\binfo\b|delivery|shipping|app)/i.test(nc)) {
              node.style.display = 'none';
              break;
            }
            node = node.parentElement;
          }
        }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideAppBlocks);
  else hideAppBlocks();
  setTimeout(hideAppBlocks, 500);
  setTimeout(hideAppBlocks, 1500);
  setTimeout(hideAppBlocks, 3000);

  /* URL prefix fix — only needed when on the subfolder (pre-cutover staging).
     On the dedicated domain (artmie.it) all internal /xxx links resolve correctly. */
  var MARKET_PREFIX = pathMode ? '/it-it' : '';
  var MARKET_PREFIX_RX = /^\/(it-it|sl-si|sk-si|de-de|de-at)(?:\/|$|\?|#)/;
  var SK_HOST_RX = /^https?:\/\/(www\.)?(app\.artmie\.sk|artmie\.sk|czartmie\.myshopify\.com)/i;
  var SKIP_PATH_RX = /^\/(cart|checkout|localization|account\/login|account\/register|account\/logout|password|wpm@|tools\/|s\/files\/|recommendations\/|search\/suggest|apps\/|api\/|services\/|admin)(\/|\?|$)/;
  function normaliseHref(h) {
    if (!h) return null;
    if (/^(mailto:|tel:|sms:|javascript:|#)/i.test(h)) return null;
    if (!pathMode) return null; /* on dedicated domain — no prefix rewriting needed */
    if (SK_HOST_RX.test(h)) {
      h = h.replace(SK_HOST_RX, '');
      if (h === '' || h === '/') h = '/';
    } else if (/^https?:/i.test(h)) {
      return null;
    }
    if (h.charAt(0) !== '/') return null;
    if (MARKET_PREFIX_RX.test(h)) return null;
    /* Fix accidental concat like '/it-itpages/...' */
    var fixedConcat = h.match(new RegExp('^\\/it-it([a-z])'));
    if (fixedConcat) return '/hr-hr/' + h.slice(6);
    if (SKIP_PATH_RX.test(h)) return null;
    if (h === '/') return MARKET_PREFIX + '/';
    var stripped = h.replace(/^\/(sk|it)(\/|$)/, '/');
    return MARKET_PREFIX + stripped;
  }
  function fixHrefPrefix() {
    if (!pathMode) return;
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var h = a.getAttribute('href');
      var newH = normaliseHref(h);
      if (newH && newH !== h) a.setAttribute('href', newH);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixHrefPrefix);
  else fixHrefPrefix();
  setTimeout(fixHrefPrefix, 500);
  setTimeout(fixHrefPrefix, 1500);
  setTimeout(fixHrefPrefix, 3000);

  /* SK → IT text rewrites */
    var TEXT_REWRITES = {
  "Stolové, ateliérové, poľné": "Stolni, atelijerski, poljski",
  "Späť na ": "Natrag na ",
  "Späť do obchodu": "Natrag u trgovinu",
  "Najnovšie články": "Najnoviji članci",
  "Zobraziť všetky": "Prikaži sve",
  "min čítania": "min čitanja",
  "Čítať článok": "Pročitaj članak",
  "Čítať viac": "Pročitaj više",
  "min. čítania": "min. čitanja",
  "čítania": "čitanja",
  "Všetko": "Sve",
  "Hodnotenia zákazníkov": "Ocjene kupaca",
  "hodnoteni": "ocjena",
  "hodnotení": "ocjena",
  "Recenzie": "Recenzije",
  "recenzia": "recenzija",
  "recenzií": "recenzija",
  "Napísať recenziu": "Napiši recenziju",
  "Overená recenzia": "Provjerena recenzija",
  "Overena recenzia": "Provjerena recenzija",
  "Ďakujeme za tvoju recenziu": "Hvala na tvojoj recenziji",
  "Tvoje hodnotenie": "Tvoja ocjena",
  "Podeľ sa o svoju skúsenosť": "Podijeli svoje iskustvo",
  "Pridať recenziu": "Dodaj recenziju",
  "Pridať do košíka": "Dodaj u košaricu",
  "Do košíka": "U košaricu",
  "DO KOŠÍKA": "U KOŠARICU",
  "Pridané do košíka": "Dodano u košaricu",
  "Pridať všetky do košíka": "Dodaj sve u košaricu",
  "Košík je prázdny": "Košarica je prazna",
  "Nákupný košík": "Košarica",
  "Košík": "Košarica",
  "v košíku": "u košarici",
  "Zatvoriť": "Zatvori",
  "Zavrieť": "Zatvori",
  "Otvoriť": "Otvori",
  "Zobraziť": "Prikaži",
  "Zobraziť všetko": "Prikaži sve",
  "Zobraziť viac": "Prikaži više",
  "Zobraziť menej": "Prikaži manje",
  "Skryť": "Sakrij",
  "Späť": "Natrag",
  "Pokračovať": "Nastavi",
  "Pokračovať v nákupe": "Nastavi s kupnjom",
  "Pokračovať na pokladňu": "Nastavi na blagajnu",
  "Hľadať": "Pretraži",
  "Vyhľadať": "Pretraži",
  "Vyhľadávanie": "Pretraživanje",
  "Vymazať": "Obriši",
  "Vymazať všetko": "Obriši sve",
  "Triediť": "Sortiraj",
  "Zoradiť": "Sortiraj",
  "Načítavanie": "Učitavanje",
  "Načítavam": "Učitavam",
  "Načítava sa": "Učitavanje",
  "Načítať viac": "Učitaj više",
  "Popis": "Opis",
  "Vyberte": "Odaberi",
  "Vyberte si": "Odaberi",
  "Veľkosť": "Veličina",
  "Farba": "Boja",
  "Materiál": "Materijal",
  "Značka": "Brend",
  "Skladom": "Na zalihi",
  "Vypredané": "Rasprodano",
  "Nedostupné": "Nedostupno",
  "Posledné kusy": "Posljednji komadi",
  "Cena": "Cijena",
  "Bežná cena": "Redovna cijena",
  "Vaša cena": "Vaša cijena",
  "Zľava": "Popust",
  "Zľavnené": "Sniženo",
  "Stiahni si aplikáciu": "Preuzmi aplikaciju",
  "Prihlásenie": "Prijava",
  "Prihlásiť sa": "Prijava",
  "Odhlásiť sa": "Odjava",
  "Registrácia": "Registracija",
  "Nová registrácia": "Nova registracija",
  "Registrovať sa": "Registriraj se",
  "Môj účet": "Moj račun",
  "Objednávky": "Narudžbe",
  "Nemáte účet": "Nemate račun",
  "Zoznam želaní": "Lista želja",
  "Pokladňa": "Blagajna",
  "Doručenie": "Dostava",
  "Súhrn objednávky": "Sažetak narudžbe",
  "Medzisúčet": "Međuzbroj",
  "Prihlásiť sa na odber": "Prijavi se na newsletter",
  "Odoberať novinky": "Pretplati se na novosti",
  "Najnovšie zľavy a inšpirácie": "Najnoviji popusti i inspiracije",
  "Súhlasím so spracovaním osobných údajov": "Slažem se s obradom osobnih podataka",
  "Nenechajte si ujsť": "Ne propustite",
  "NENECHAJTE SI UJSŤ": "NE PROPUSTITE",
  "Pomoc a informácie": "Pomoć i informacije",
  "O nás": "O nama",
  "Kontaktujte nás": "Kontaktirajte nas",
  "Sledujte nás": "Pratite nas",
  "SLEDUJTE NÁS": "PRATITE NAS",
  "Sme tu pre vás": "Tu smo za vas",
  "Odoslať": "Pošalji",
  "Poslať": "Pošalji",
  "Uložiť": "Spremi",
  "Upraviť": "Uredi",
  "Pridať": "Dodaj",
  "Odstrániť": "Ukloni",
  "Zmazať": "Obriši",
  "Potvrdiť": "Potvrdi",
  "Zrušiť": "Otkaži",
  "Áno": "Da",
  "voliteľné": "opcionalno",
  "povinné": "obavezno",
  "nepovinné": "neobavezno",
  "súbor": "datoteka",
  "súbory": "datoteke",
  "obrázok": "slika",
  "telefón": "telefon",
  "správa": "poruka",
  "odpovedať": "odgovori",
  "Tvoje meno": "Tvoje ime",
  "Tvoj email": "Tvoj e-mail",
  "Fotka alebo video": "Fotografija ili video",
  "Pri preprave bohužiaľ došlo": "Pri prijevozu je nažalost došlo",
  "Ohodnoť tento produkt": "Ocijeni ovaj proizvod",
  "Stránkovanie": "Straničenje",
  "stránka": "stranica",
  "výsledkov": "rezultata",
  "výsledok": "rezultat",
  "Hodnotenia zakaznikov": "Ocjene kupaca",
  "Hodnotenia zakazníkov": "Ocjene kupaca",
  "Hodnotenia": "Ocjene",
  "Na základe": "Na temelju",
  "Na zaklade": "Na temelju",
  "zákazníkov": "kupaca",
  "zákazník": "kupac",
  "pridať": "dodaj",
  "Pridáva sa": "Dodaje se",
  "pridáva sa": "dodaje se",
  "kúpiť teraz": "kupi sada",
  "Kúpiť teraz": "Kupi sada",
  "KÚPIŤ TERAZ": "KUPI SADA",
  "Nakup teraz": "Kupi sada",
  "na sklade": "na zalihi",
  "Na sklade": "Na zalihi",
  "NA SKLADE": "NA ZALIHI",
  "Nie je na sklade": "Nije na zalihi",
  "nie je na sklade": "nije na zalihi",
  "doručenie": "dostava",
  "doručenia": "dostave",
  "pracovných dní": "radnih dana",
  "pracovný deň": "radni dan",
  "Zákazník": "Kupac",
  "Zákaznícky servis": "Korisnička služba",
  "ZÁKAZNÍCKY SERVIS": "KORISNIČKA SLUŽBA",
  "Alternatívne Produkty": "Alternativni proizvodi",
  "Alternatívne produkty": "Alternativni proizvodi",
  "ALTERNATÍVNE PRODUKTY": "ALTERNATIVNI PROIZVODI",
  "Alternatívny produkt": "Alternativni proizvod",
  "alternatívne": "alternativno",
  "zákaznícky servis": "korisnička služba",
  "Farby a médiá": "Boje i mediji",
  "Plátna a papiere": "Platna i papiri",
  "Štetce a pomôcky": "Kistovi i pomagala",
  "Kreatívne potreby": "Kreativni pribor",
  "Značky": "Brendovi",
  "Akryl, olej, akvarel": "Akril, ulje, akvarel",
  "Na ráme, rolky, bloky": "Na okviru, role, blokovi",
  "Stolové, ateliérové, poľné": "Stolni, atelijerski, poljski",
  "Zľavy až -80%": "Popusti do -80%",
  "Zľavy až": "Popusti do",
  "Akrylové, olejové, akvarelové": "Akrilne, uljne, akvarelne",
  "Kreslenie a ilustrácia": "Crtanje i ilustracija",
  "Sady, guľaté, ploché": "Setovi, okrugli, plosnati",
  "Živica, dekupáž, šperky": "Smola, dekupaž, nakit",
  "O tejto kategórii": "O ovoj kategoriji",
  "O TEJTO KATEGÓRII": "O OVOJ KATEGORIJI",
  "O kategórii": "O kategoriji",
  "Doručenie do 1–2 pracovných dní": "Dostava unutar 1–2 radna dana",
  "Doručenie do 1-2 pracovných dní": "Dostava unutar 1-2 radna dana",
  "Doručenie do 1–2 dní": "Dostava unutar 1–2 dana",
  "Doručenie do 1-2 dní": "Dostava unutar 1-2 dana",
  "S Packeta od 2,10 € · Zdarma nad 49 €": "Uz Packeta od 2,10 € · Besplatno iznad 49 €",
  "S Packeta od 2,10 €": "Uz Packeta od 2,10 €",
  "S Packeta od": "Uz Packeta od",
  "Zdarma nad 49 €": "Besplatno iznad 49 €",
  "S aplikáciou doprava zdarma už od 45 €": "Uz aplikaciju besplatna dostava već od 45 €",
  "S aplikáciou doprava zdarma": "Uz aplikaciju besplatna dostava",
  "100-dňové vrátenie bez udania dôvodu": "100-dnevni povrat bez navođenja razloga",
  "100-dňové vrátenie": "100-dnevni povrat",
  "bez udania dôvodu": "bez navođenja razloga",
  "Jednoducho a bez starostí": "Jednostavno i bez briga",
  "Dnes Doprava ZADARMO Od 49€": "Danas dostava BESPLATNO od 49€",
  "Doprava ZADARMO Od 49€": "Dostava BESPLATNO od 49€",
  "Doprava ZADARMO Od 49 €": "Dostava BESPLATNO od 49 €",
  "Doprava ZADARMO od 49€": "Dostava BESPLATNO od 49€",
  "Doprava ZADARMO od 49 €": "Dostava BESPLATNO od 49 €",
  "doprava zadarmo od 49€": "dostava besplatno od 49€",
  "Doprava ZADARMO": "Dostava BESPLATNO",
  "DOPRAVA ZADARMO": "DOSTAVA BESPLATNO",
  "doprava zadarmo": "dostava besplatno",
  "Od 49€": "Od 49€",
  "od 49€": "od 49€",
  "od 49 €": "od 49 €",
  "už od 49€": "već od 49€",
  "už od 49 €": "već od 49 €",
  "ARTMIE Slovenija": "ARTMIE Slovenija",
  "ARTMiE.SK": "ARTMiE.SK",
  "ARTMIE.SK": "ARTMIE.SK",
  "info@artmie.sk": "info@artmie.sk",
  "INFO@ARTMIE.SK": "INFO@ARTMIE.SK",
  "info@artmie.com": "info@artmie.com",
  "INFO@ARTMIE.COM": "INFO@ARTMIE.COM",
  "reklamacie@artmie.sk": "reklamacie@artmie.sk",
  "reklamacie@artmie.com": "reklamacie@artmie.com",
  "artmie.sk": "artmie.sk",
};;

  /* Loop guard: filter out pairs whose replacement contains the source */
  var TEXT_KEYS = Object.keys(TEXT_REWRITES)
    .filter(function (k) { return TEXT_REWRITES[k].indexOf(k) === -1; })
    .sort(function (a, b) { return b.length - a.length; });

  /* ARTMIE_PERF_REWRITER_2026-07-07 v2 — engine optimization, behavior-identical:
     (1) ONE precompiled combined regex (TEXT_KEYS already longest-first; JS alternation
         picks the first alternative at a position, preserving longest-first semantics);
     (2) MutationObserver walks ONLY ADDED subtrees, not the whole body.
     Revert: cmp/rewriterbackups/. */
  var COMBINED_RX = null;
  try {
    COMBINED_RX = new RegExp(TEXT_KEYS.map(function (k) {
      return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }).join('|'), 'g');
  } catch (e) {}
  function rewriteViaMap(m) { return Object.prototype.hasOwnProperty.call(TEXT_REWRITES, m) ? TEXT_REWRITES[m] : m; }
  function rewriteTextNode(node) {
    if (!node || node.nodeType !== 3) return;
    var t = node.nodeValue;
    if (!t || !/\S/.test(t) || !COMBINED_RX) return;
    COMBINED_RX.lastIndex = 0;
    var newT = t.replace(COMBINED_RX, rewriteViaMap);
    if (newT !== t) node.nodeValue = newT;
  }
  function rewriteString(v) {
    if (!v || !COMBINED_RX) return v;
    COMBINED_RX.lastIndex = 0;
    return v.replace(COMBINED_RX, rewriteViaMap);
  }
  function walkAndRewrite(root) {
    if (!root) return;
    if (root.nodeType === 3) { rewriteTextNode(root); return; }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var n; while ((n = w.nextNode())) rewriteTextNode(n);
    var ATTR_SELECTORS = ['[placeholder]', '[alt]', '[title]', '[aria-label]', 'input[type="submit"]', 'input[type="button"]', 'button'];
    var atrs = root.querySelectorAll ? root.querySelectorAll(ATTR_SELECTORS.join(',')) : [];
    for (var i = 0; i < atrs.length; i++) {
      var el = atrs[i];
      ['placeholder', 'alt', 'title', 'aria-label', 'value'].forEach(function (a) {
        var v = el.getAttribute(a);
        if (!v) return;
        var nv = rewriteString(v);
        if (nv !== v) el.setAttribute(a, nv);
      });
    }
  }
  function initialPass() { walkAndRewrite(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialPass);
  else initialPass();

  var pendingNodes = [];
  var pending = null;
  function flushPending() {
    pending = null;
    var nodes = pendingNodes; pendingNodes = [];
    for (var i = 0; i < nodes.length; i++) { if (nodes[i]) walkAndRewrite(nodes[i]); }
    fixHrefPrefix();
  }
  function startObserver() {
    if (!document.body) { setTimeout(startObserver, 100); return; }
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var nd = added[j];
            if (nd.nodeType === 1 || nd.nodeType === 3) pendingNodes.push(nd);
          }
        }
        if (pendingNodes.length && !pending) pending = setTimeout(flushPending, 300);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  startObserver();

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href');
    var newH = normaliseHref(h);
    if (newH && newH !== h) a.setAttribute('href', newH);
  }, true);
})();
